var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeighing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6944_14563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1834 0H2.81664C1.26369 0 0 1.26369 0 2.81664V16.1833C0 17.7363 1.26369 19 2.81664 19H16.1833C17.7363 19 19 17.7363 19 16.1834V2.81664C19 1.26369 17.7363 0 16.1834 0ZM10.0816 17.5653H8.91835V12.5633H10.0816V17.5653ZM13.9487 6.78571H10.0816V3.67631H8.91835V6.78571H5.05129V6.77524C5.05129 4.31842 7.04317 2.32654 9.5 2.32654C11.9568 2.32654 13.9487 4.31842 13.9487 6.77524V6.78571Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6944_14563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeighing);
export default __webpack_public_path__ + "static/media/weighing.48ce132c7f59b20acbba675c76f36869.svg";
export { ForwardRef as ReactComponent };